module.exports = __webpack_public_path__ + "distVue/img/expandAppDl_zs.36200875.png";